import { render } from "./MagentoFeedback.vue?vue&type=template&id=e604cff2"
import script from "./MagentoFeedback.vue?vue&type=script&lang=js"
export * from "./MagentoFeedback.vue?vue&type=script&lang=js"

import exportComponent from "/home/webdevs/livesite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__